import { Box } from "@mui/material";
import FMRLogo from "../../FMRLogo/FMRLogo";

const NavLogo = ({ isMobile = false }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
      position: isMobile ? "absolute" : "static",
      left: isMobile ? "50%" : "auto",
      transform: isMobile ? "translateX(-50%)" : "none",
      zIndex: 1,
    }}
  >
    <FMRLogo variant="navbar" to="/fmr" />
  </Box>
);

export default NavLogo;